<template>
    <div class="uploadTalonFuelPricesDashboard">
        <div class="uploadTalonFuelPricesDashboard__header">
            <div class="uploadTalonFuelPricesDashboard__title">Talon fuel price</div>
        </div>
        <div class="uploadTalonFuelPricesDashboard__row">Source list</div>
        <input class="uploadTalonFuelPricesDashboard__row" type="file" @change="uploadMainListV2" ref="mainFile">
        <div class="uploadTalonFuelPricesDashboard__button">
          <span class="text" @click="uploadTalonFuelPrices">Upload</span>
        </div>
    </div>
</template>

<script>
import { airportFulePriceAPI } from '@/api/airportFuelPrice'
import './UploadTalonFuelPrices.styl'
import * as XLSX from 'xlsx'

export default {
    name: 'upload-talon-fuel-prices',
    data: () => ({
      mainList: [],
    }),
    methods: {
      parseCsvRow (line) {
        const fields = [];
        let current = '';
        let inQuotes = false;

        for (let i = 0; i < line.length; i++) {
          const char = line[i];

          if (char === '"') {
            if (inQuotes && line[i + 1] === '"') {
              current += '"';
              i++;
            } else {
              inQuotes = !inQuotes;
            }
          } else if (char === ',' && !inQuotes) {
            fields.push(current);
            current = '';
          } else {
            current += char;
          }
        }

        fields.push(current);
        return fields;
      },
      async uploadMainList (event) {
        this.mainList = [];
        const file = event.target.files[0];
        if (!file) return;

        const data = await file.arrayBuffer();

        const workbook = XLSX.read(data, {
          type: 'array',
        });

        const sheet = workbook.Sheets['Price List'];
        if (!sheet) {
          console.error('Sheet "Price List" not found');
          return;
        }

        const rows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          raw: true,
        });

        for (let i = 4; i < rows.length; i++) {
          const row = rows[i];
          if (!row) continue;

          const provider = row[6]; // H
          const price = row[7]; // I
          const airportCode = row[8]; // J
          const fuelSupplier = row[10]; // L
          const bottomBorder = row[11] ? parseInt(row[11]) : undefined; // M
          const topBorder = row[12] ? parseInt(row[12]) : undefined; // N

          if (typeof airportCode === 'string' && typeof price === 'number' && provider !== ' JE Tails ') {
            if (typeof provider === 'string' && provider.trim() === 'JE Tails') {
              console.log(provider);
              continue;
            }
            this.mainList.push({
              airportCode: airportCode.trim(),
              fuelSupplier: fuelSupplier.trim(),
              price,
              bottomBorder: typeof bottomBorder === 'number' ? bottomBorder : null,
              topBorder: typeof topBorder === 'number' ? topBorder : null,
            });
          }
        }
      },
      async uploadMainListV2 (event) {
        const reader = new FileReader();
        const scope = this;
        reader.onload = function (progressEvent) {
          const rows = this.result.split(/\r?\n/);

          for (let i = 1; i < rows.length; i++) {
            try {
              if (!rows[i]) continue;

              const row = scope.parseCsvRow(rows[i]);

              const price = row[10]; // K

              if (isNaN(price)) continue;

              const airportCode = row[0]; // A
              const fuelSupplier = row[4]; // E
              const bottomBorder = row[8] ? parseInt(row[8]) : undefined; // I
              const topBorder = row[9] ? parseInt(row[9]) : undefined; // J

              if (typeof airportCode === 'string') {
                scope.mainList.push({
                  airportCode: airportCode.trim(),
                  fuelSupplier: fuelSupplier.trim(),
                  price,
                  bottomBorder: isNaN(bottomBorder) ? null : bottomBorder,
                  topBorder: isNaN(topBorder) ? null : topBorder,
                });
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
        reader.readAsText(this.$refs.mainFile.files[0]);
      },
      async uploadTalonFuelPrices () {
        try {
          const result = await airportFulePriceAPI.uploadFuelPrices(this.mainList);
          console.log(result);
        } catch (e) {
          console.log(e)
        }
      },
    },
}
</script>